exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".svgIconComponent---qOa8m {\n  display: block;\n  pointer-events: none;\n  width: 12px;\n  background: transparent !important; }\n  .svgIconComponent---qOa8m > span {\n    background: transparent; }\n  .svgIconComponent---qOa8m > span > svg {\n      background: transparent; }\n  .dueDateInfoIcon---1OcNj {\n  display: block;\n  pointer-events: none;\n  width: 17px;\n  height: 17px;\n  background: transparent !important; }\n  .dueDateInfoIcon---1OcNj > span {\n    background: transparent; }\n  .dueDateInfoIcon---1OcNj > span > svg {\n      background: transparent; }\n", ""]);

// exports
exports.locals = {
	"svgIconComponent": "svgIconComponent---qOa8m",
	"dueDateInfoIcon": "dueDateInfoIcon---1OcNj"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/svg-icon/svg-icon.scss
// module id = eag5
// module chunks = 1